import request from '../request.js'

// 获取菜单信息
const getTreeTablePageList = function (data) {
    return request({
        url: 'busDict/getTreeTablePageList',
        method: 'post',
        data
    })
}

const getTreeTableList = function (data) {
    return request({
        url: 'busDict/getTreeTableList',
        method: 'post',
        data
    })
}

const saveOrUpdate = function (data) {
    return request({
        url: 'busDict/saveOrUpdate',
        method: 'post',
        data
    })
}

const getInfoById = function (data) {
    return request({
        url: 'busDict/getInfoById',
        method: 'post',
        data
    })
}

const deleteById = function (data) {
    return request({
        url: 'busDict/deleteById',
        method: 'post',
        data
    })
}

const getDictByParentValue = function (data) {
    return request({
        url: 'sysDict/getDictByParentValue',
        method: 'post',
        data
    })
}

const getPageLogList = function (data) {
    return request({
        url: 'sysLog/getPageList',
        method: 'post',
        data
    })
}

// 获取组织架构
const getSysDept = function (data) {
    return request({
        url: 'sysDept/selectDeptTree',
        method: 'post',
        data
    })
}

// 新增组织架构
const insertSysDept = function (data) {
    return request({
        url: 'sysDept/insert',
        method: 'post',
        data
    })
}

// 删除组织架构
const deleteSysDept = function (data) {
    return request({
        url: 'sysDept/deleteById',
        method: 'post',
        data
    })
}

// 获取组织架构信息
const getDeptInfo = function (data) {
    return request({
        url: 'sysDept/selectById',
        method: 'post',
        data
    })
}

// 获取用户组所属组织
const getGroupDepts = function (data) {
    return request({
        url: 'sysDept/selectGroupDepts',
        method: 'post',
        data
    })
}

const getUserToSystemVersion = function (data) {
    return request({
        url: 'sysVersionNotify/getUserToSystemVersion',
        method: 'post',
        data
    })
}

//zwh-接口信息
const getAddCheckInterfaceList = function (data) {  //获取所有接口信息,已根据菜单id，过了已添加的接口信息
    return request({
        url: 'sysInterface/getAddCheckInterfaceList',
        method: 'post',
        data
    })
}

//zwh-菜单接口信息
const getMenuInterfaceList = function (data) {  //菜单接口列表信息（不分页）
    return request({
        url: 'sysInterface/getMenuInterfaceList',
        method: 'post',
        data
    })
}
const getPageExceptionList = function (data) {
    return request({
        url: 'sysExceptionInfo/getPageList',
        method: 'post',
        data
    })
}


//分页列表
const getPageVersionList = function (data) {
    return request({
        url: 'sysVersionInfo/getPageList',
        method: 'post',
        data
    })
}

const getVersionInfoById = function (data) {
    return request({
        url: 'sysVersionInfo/getInfoById',
        method: 'post',
        data
    })
}

//保存/更新
const saveOrUpdateVersion = function (data) {
    return request({
        url: 'sysVersionInfo/saveOrUpdate',
        method: 'post',
        data
    })
}
//最新版本信息

const getNewVersion = function (data) {
    return request({
        url: 'sysVersionInfo/getNewVersion',
        method: 'post',
        data
    })
}
const deleteVersionById = function (data) {
    return request({
        url: 'sysVersionInfo/deleteById',
        method: 'post',
        data
    })
}

//获取所有字典（二级）
const selectAllDicts = function (data) {
    return request({
        url: 'sysDict/selectAllDicts',
        method: 'post',
        data
    })
}

//新增编码（叶凡）
const saveSysCode = function (data) {
    return request({
        url: 'sysCode/saveSysCode',
        method: 'post',
        data
    })
}


//查询编码列表数据（叶凡）
const selectCodeAll = function (data) {
    return request({
        url: 'sysCode/selectCodeAll',
        method: 'post',
        data
    })
}

//删除编码（叶凡）
const deleteCode = function (data) {
    return request({
        url: 'sysCode/deleteCode',
        method: 'post',
        data
    })
}

export {
    getTreeTablePageList,
    getTreeTableList,
    saveOrUpdate,
    getInfoById,
    deleteById,
    getDictByParentValue,
    getPageLogList,
    getSysDept,
    insertSysDept,
    deleteSysDept,
    getDeptInfo,
    getGroupDepts,
    getMenuInterfaceList,
    getAddCheckInterfaceList,
    getUserToSystemVersion,
    getPageExceptionList,
    getPageVersionList,
    deleteVersionById,
    saveOrUpdateVersion,
    getVersionInfoById,
    getNewVersion,
    selectAllDicts,
    saveSysCode,
    selectCodeAll,
    deleteCode
}
